import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { PreSelectedPipe } from "@bca-compose/pipes/pre-selected.pipe";
import { ChooseExtrasComponent } from "@bca-compose/products-overview/choose-extras/choose-extras.component";
import { ProductAddonComponent } from "@bca-compose/products-overview/choose-extras/product-addon/product-addon.component";
import { ProductServiceComponent } from "@bca-compose/products-overview/choose-extras/product-service/product-service.component";
import { ChooseStationComponent } from "@bca-compose/products-overview/choose-route/choose-station/choose-station.component";
import { RouteSummaryComponent } from "@bca-compose/products-overview/choose-route/route-summary/route-summary.component";
import { ProductsOverviewComponent } from "@bca-compose/products-overview/products-overview.component";
import { ReceiptModule } from "@bca-receipt/receipt.module";
import { ProductInfoModule } from "@bca-shared/modules/product-info/product-info.module";
import { TypeAheadModule } from "@bca-shared/modules/type-ahead/type-ahead.module";
import { SharedModule } from "@bca-shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { ChooseRouteDialogComponent } from "./products-overview/choose-route/choose-route-dialog.component";
import { DecisionAidComponent } from "./products-overview/decision-aid/decision-aid.component";
import { ProductCardComponent } from "./products-overview/product-card/product-card.component";
import { ProductDialogComponent } from "./products-overview/product-dialog/product-dialog.component";
import { ProductsOverviewSkeletonComponent } from "./products-overview/products-overview-skeleton/products-overview-skeleton.component";

@NgModule({
  declarations: [
    ProductsOverviewComponent,
    ChooseExtrasComponent,
    ProductAddonComponent,
    ProductServiceComponent,
    ChooseRouteDialogComponent,
    ProductDialogComponent,
    ChooseStationComponent,
    RouteSummaryComponent,
    PreSelectedPipe,
    ProductCardComponent,
    DecisionAidComponent,
    ProductsOverviewSkeletonComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    ReceiptModule,
    TypeAheadModule,
    ProductInfoModule,
    TranslateModule.forChild(),
  ],
  exports: [ProductsOverviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComposeModule {}
